<template>
    <div>
        <error :name="'403'" :desc="'抱歉，你无权访问该页面'"></error>
    </div>
</template>

<script>
    import error from '@/components/error.vue';
    export default {
        components: {
            error
        }
    }
</script>
